import { callBackendService } from "../index";
const win: any = window;
//const token = 'fb1f4b97-e3fd-4beb-988a-dd78ac115990';
const token = win["clientToken"];

const getInquiryTypes = async () =>
  await callBackendService(`contactus/v1/inquiry-types`, "get", null, token);
const sendContactUsRequest = async (payload: any) =>
  await callBackendService(`contactus/v1/request`, "post", payload, token);

export const ContactUsApi = { getInquiryTypes, sendContactUsRequest };
